import { datadogRum } from '@datadog/browser-rum';

declare global {
  interface Window {
    __DATADOG_INITIALIZED__: boolean;
  }
}

const isLocalDev = window.location.origin.indexOf('://local') > -1;
const fullStoryUrlRegex = /https:\/\/.*\.fullstory\.com/;

if (!isLocalDev) {
  if (!window.__DATADOG_INITIALIZED__) {
    datadogRum.init({
      allowedTracingUrls: [
        'https://apix-qa.ingrammicro.com',
        /https:\/\/.*\.ingrammicro\.com/,
      ],
      applicationId: '12444269-de97-4ca2-865e-ad1167bb4dd5',
      beforeSend: (event: any, context: any) => {
        if (event.type === 'resource' && event.resource.type === 'fetch') {
          if (context?.response?.headers) {
            event.context.responseHeaders = Object.fromEntries(
              context.response.headers
            );
          }
        }
        if (shouldDiscard(event, context)) {
          return false;
        }

        return true;
      },
      clientToken: 'pub92d4bf1905a9bc788affd0f5cb63e8cc',
      defaultPrivacyLevel: 'mask-user-input',
      excludedActivityUrls: [
        /^https:\/\/.*\.fullstory\.com/,
        /^https:\/\/.*\.adobedc\.net/,
        /^https:\/\/whatfix\.com/,
      ],
      service: 'cep',
      sessionReplaySampleRate: 100,
      sessionSampleRate: 100,
      site: 'us5.datadoghq.com',
      env:'production',
      trackLongTasks: true,
      trackResources: true,
      trackSessionAcrossSubdomains: true,
      trackUserInteractions: true,
      usePartitionedCrossSiteSessionCookie: true,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: '25.6.2',
    });
    window.__DATADOG_INITIALIZED__ = true;
  }
}

function shouldDiscard(event: any, context: any) {
  return (
    event.type === 'resource' &&
    context.xhr &&
    fullStoryUrlRegex.test(context.xhr.responseURL)
  );
}
